import { CheckTableComponent } from "@app/shared";

export class ModifyWindowConfigService {
  //Configuraciones de la tabla
  settings = {};

  constructor(){
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay pestañas',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        pestana: {
          editable: false,
          addable: false,
          title: 'Pestaña',
          filter: {
            inputClass: 'form-control',
          },
        },
        nombre: {
          editable: false,
          addable: false,
          title: 'Título de la pestaña',
          filter: {
            inputClass: 'form-control',
          },
        },
        modificable: {
          editable: false,
          addable: false,
          title: 'Pestaña modificable',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'false',
              resetText: 'Todo',
            },
          },
        }
      },
    };
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/modify-window/shared/modify-window.config.service.ts